import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-formcontrol-group',
  template: require('./formcontrol-group.component.html'),
  styles: [require('./formcontrol-group.component.scss')],
})
export class FormcontrolGroupComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() field: string;
  @Input() displayName: string;
  @Input() schema: any;
  @Input() disabled: boolean;
  schemaKeys: any[];

  constructor(
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.schemaKeys = Object.keys(this.schema.paths);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/admin/shared/formcontrol-group/formcontrol-group.component.ts